import React, { useState } from "react";
import dayjs from "dayjs";
import { AiModal } from "./index.jsx";
import { conditionFormatter } from "../../../../core/utils/formatters";

const LeadsItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onHide = () => {
    setIsOpen(false);
  };

  return (
    <>
      <tr onClick={() => setIsOpen(true)}>
        <td>
          <div
            className={`quote-status ${
              item.messageStatus === "approved" ? "green approved" : ""
            }`}
          />
        </td>

        <td>{dayjs(item.created_at).format("DD/MM/YYYY")}</td>

        <td>
          {item.client?.first_name} {item.client?.last_name}
        </td>

        <td>{conditionFormatter(item?.condition)}</td>

        <td>{item.year}</td>
      </tr>
      <AiModal isOpen={isOpen} item={item} hide={onHide} />
    </>
  );
};

export default LeadsItem;
